import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { Promises } from "@/components/site/Promises";
import { Process } from "@/components/site/Process";
import { About } from "@/components/site/About";
import { Portfolio } from "@/components/site/Portfolio";
import { Contact } from "@/components/site/Contact";
import {
  Seo,
  SITE,
  organizationJsonLd,
  websiteJsonLd,
} from "@/components/site/Seo";

const servicesJsonLd = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Leistungen von LiberoX Labs",
  itemListElement: [
    "KI-Agenten & Automatisierung",
    "Web-Apps & Plattformen",
    "iOS & Android (Native)",
    "Cross-Platform Apps",
    "UI/UX Design",
    "Backend, APIs & Cloud",
    "Wartung & Support",
  ].map((name, i) => ({
    "@type": "ListItem",
    position: i + 1,
    item: { "@type": "Service", name, provider: { "@type": "Organization", name: SITE.name } },
  })),
};

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    // Scroll to hash target when navigating from another page (e.g. /projekte -> /#leistungen)
    if (location.hash) {
      const id = location.hash.replace("#", "");
      // Wait for sections to render
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 120);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0 });
  }, [location]);

  return (
    <>
      <Seo
        path="/"
        jsonLd={[organizationJsonLd(), websiteJsonLd(), servicesJsonLd]}
      />
      <Hero />
      <Services />
      <Promises />
      <Process />
      <About />
      <Portfolio />
      <Contact />
    </>
  );
}
